import { render } from "./photo-9.vue?vue&type=template&id=273684f4&scoped=true"
import script from "./photo-9.vue?vue&type=script&lang=js"
export * from "./photo-9.vue?vue&type=script&lang=js"

import "./photo-9.vue?vue&type=style&index=0&id=273684f4&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273684f4"]])

export default __exports__